import { PaymentSettingsRepository } from '@lib/api/repository/payment-settings/payment-settings.repository';
import { PaymentSettingsInput } from '@lib/types';

export default class PaymentSettingsService {
  constructor(private repository: PaymentSettingsRepository) {}

  get(signal?: AbortSignal) {
    return this.repository.get(signal);
  }

  update(input: PaymentSettingsInput) {
    return this.repository.update(input);
  }
}
